import { _ as __vitePreload } from "./preload-helper-BbOs9S9B.js";
import { l as lazyInit } from "./utilities-Da0sjanJ.js";
class MediaBg extends HTMLElement {
  connectedCallback() {
    this._parallax = this.dataset.parallax === "true";
    this._parallaxStrength = this.dataset.parallaxStrength;
    if (this.hasAttribute("data-visual-preview-mode")) {
      this._inner = this.querySelector(".media-bg-block-content");
      this.classList.add("active");
      if (this._parallax && this._inner) {
        this._initAnimejs();
      }
      return;
    }
    this._reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!this._parallax || this._reducedMotion) {
      this.classList.add("active");
      return;
    }
    this._inner = this.querySelector(".media-bg-block-content");
    if (!this._inner) {
      this.classList.add("active");
      return;
    }
    if (this.dataset.deferParallax === "true") {
      this.classList.add("active");
      return;
    }
    this.classList.add("active");
    if (typeof ViewTimeline !== "undefined") return;
    if (this.dataset.sectionIndex === "1" || this.dataset.eager === "true") {
      this._initAnimejs();
    } else {
      lazyInit(this, () => this._initAnimejs());
    }
  }
  disconnectedCallback() {
    this._cleanup();
  }
  // ─── Public API (used by slideshow-v2) ────────────────────────────────
  enableParallax() {
    if (this._anim || !this._parallax || !this._inner || this._reducedMotion) return;
    if (typeof ViewTimeline !== "undefined") return;
    this._initAnimejs();
  }
  disableParallax() {
    this._cleanup();
  }
  // ─── Internal ─────────────────────────────────────────────────────────
  async _initAnimejs() {
    if (this._animating) return;
    this._animating = true;
    try {
      const [{ waapi }, { onScroll }] = await Promise.all([
        __vitePreload(() => import("./animejs-BJ1LqVVF.js").then((n) => n.i), true ? [] : void 0, import.meta.url),
        __vitePreload(() => import("./animejs-BJ1LqVVF.js").then((n) => n.a), true ? [] : void 0, import.meta.url)
      ]);
      if (this._isDestroyed || !this._inner) return;
      this._inner.style.willChange = "transform";
      this._anim = waapi.animate(this._inner, {
        translateY: [`-${this._parallaxStrength}%`, "0%"],
        scale: [this._parallaxStrength / 100 + 1, this._parallaxStrength / 100 + 1],
        ease: "linear",
        composition: "replace",
        autoplay: onScroll({
          target: this,
          enter: "top bottom",
          leave: "bottom top",
          sync: true
        })
      });
    } finally {
      this._animating = false;
    }
  }
  _cleanup() {
    this._isDestroyed = true;
    if (this._anim) {
      this._anim.revert();
      this._anim = null;
    }
    if (this._inner) {
      this._inner.style.willChange = "";
      this._inner.style.transform = "";
    }
  }
}
if (!customElements.get("media-bg-component")) {
  customElements.define("media-bg-component", MediaBg);
}
